import { render, staticRenderFns } from "./two_puzzle_offer.vue?vue&type=template&id=d7f0327a&scoped=true&"
import script from "./two_puzzle_offer.vue?vue&type=script&lang=js&"
export * from "./two_puzzle_offer.vue?vue&type=script&lang=js&"
import style0 from "./two_puzzle_offer.vue?vue&type=style&index=0&id=d7f0327a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7f0327a",
  null
  
)

export default component.exports